import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=28057c01"
import script from "./DeliveryAddress.vue?vue&type=script&lang=ts"
export * from "./DeliveryAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports